import { Component, OnDestroy, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { StorageService } from '../../services/storage-service';
import { BehaviorSubject, interval, map, startWith, Subject, Subscription, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgOtpInputModule } from 'ng-otp-input';
import { AppUrl } from '../../appUrl';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '../../shareds/translate/translate.module';
@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [ButtonModule, CommonModule, NgOtpInputModule, TranslateModule],
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit, OnDestroy {

  refItem: any
  refOtp: string = ""
  constructor(private st: StorageService,
    private http: HttpClient,
    private router: Router,
    private ac: ActivatedRoute
  ) {

  }

  otp = '';
  onOtpChange(v: string) {
    this.otp = v;
  }

  endTime = '';
  expired: boolean = false;
  expired$ = new BehaviorSubject<boolean>(false);
  remainText$ = new BehaviorSubject<string>('0:00');
  private destroy$ = new Subject<void>();

  ngOnInit() {
    const ref = JSON.parse(this.st.getSession('refItem') as any);
    this.refItem = ref;
    this.endTime = this.refItem?.otpExpire ?? '';
    // this.endTime = '2026-02-18T14:06:00.7100588+07:00';
    const endMs = new Date(this.endTime).getTime();

    // เช็คก่อนว่า parse ได้ไหม
    if (!this.endTime || Number.isNaN(endMs)) {
      this.expired$.next(true);
      this.remainText$.next('0:00');
      return;
    }

    interval(1000).pipe(
      startWith(0),
      takeUntil(this.destroy$),
      map(() => endMs - Date.now())
    ).subscribe((remainMs) => {
      this.expired = remainMs <= 0;
      this.expired$.next(this.expired);
      this.remainText$.next(this.formatRemain(remainMs));
      if (this.expired) this.destroy$.next();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  pad2(n: number) { return String(n).padStart(2, '0'); }

  formatRemain(ms: number) {
    const totalSec = Math.max(0, Math.floor(ms / 1000));
    const hours = Math.floor(totalSec / 3600);
    const mins = Math.floor((totalSec % 3600) / 60);
    const secs = totalSec % 60;
    return `${this.pad2(mins)}:${this.pad2(secs)}`;
  }

  getOTP() {
    this.http.post('/api/Public/AuthHotel/Register/OTP', { email: this.refItem.email }).subscribe({
      next: (res: any) => {
        let model = res.data
        model.email = this.refItem.email
        sessionStorage.setItem('refItem', JSON.stringify(model))
        window.location.reload()
      }
    })
  }

  verify() {
    if (this.otp.length != 6) return
    let model = {
      "otpReference": this.refItem.otpReference,
      "otpNumber": this.otp
    }
    this.http.post('/api/Public/AuthHotel/Register/Verify', model).subscribe({
      next: (res: any) => {
        this.st.setTokens(res.data)
        this.st.removeSession('refItem')
        const bookingData = this.st.getSession('bookingData')
        if (bookingData) {
          this.router.navigate(['/', AppUrl.customer_info, this.ac.snapshot.params['app-id']])
        } else {
          this.router.navigate(['/', AppUrl.list_room, this.ac.snapshot.params['app-id']])
        }
      }
    })
  }

  toBack() {
    this.router.navigate(['/', AppUrl.signin, this.ac.snapshot.params['app-id']])
  }
}
